
/*
    Display for the summary information of the starter sheet report
*/

import React from "react";

import DataItem from "../Components/DataItem";

/*

TotalTrips: "877"
DepartedTrips: "0"
TotalOnTime: "0"
OnTimePercent: "0"
TotalReassigned: "0"

AverageDelayDeparted: "0"
AverageDelayLate: "0"
AveragePassengers: "0"

TotalPassArriving: ""
TotalPassBoarding: ""
TotalPassDeparting: ""
TotalPassGettingOff: ""
TotalPassLeftBehind: ""

*/

const StarterSheetSummary = (props) => {

    
    const summary = props.summary;

    console.log({props, summary});

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            placeItems: "center"
        }}>
            <div style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridColumnGap: "12px"
            }}>
                <div>
                    Total Trips: 
                </div>
                <DataItem val={summary.TotalTrips}/>
                <div>
                    Departed Trips: 
                </div>
                <DataItem val={summary.DepartedTrips}/>
                <div>
                    Total On Time: 
                </div>
                <DataItem val={summary.TotalOnTime}/>
                <div>
                    On Time Percent: 
                </div>
                <DataItem val={summary.OnTimePercent}/>
                <div>
                    Total Reassigned: 
                </div>
                <DataItem val={summary.TotalReassigned}/>
                <br /><div></div>
                <div>
                    Average Delay Departed: 
                </div>
                <DataItem val={summary.AverageDelayDeparted}/>
                <div>
                    Average Delay Late: 
                </div>
                <DataItem val={summary.AverageDelayLate}/>
                <div>
                    Average Passengers: 
                </div>
                <DataItem val={summary.AveragePassengers}/>
                <br /><div></div>
                <div>
                    Total Pass Arriving: 
                </div>
                <DataItem val={summary.TotalPassArriving} />
                <div>
                    Total Pass Boarding: 
                </div>
                <DataItem val={summary.TotalPassBoarding}/>
                <div>
                    Total Pass Departing: 
                </div>
                <DataItem val={summary.TotalPassDeparting}/>
                <div>
                    Total Pass Getting Off: 
                </div>
                <DataItem val={summary.TotalPassGettingOff}/>
                <div>
                    Total Pass Left Behind: 
                </div>
                <DataItem val={summary.TotalPassLeftBehind}/>
            </div>
        </div>
    );
}

export default StarterSheetSummary;